import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
  name: "repeat",
  standalone: true,
})
export class RepeatPipe implements PipeTransform {
  transform(value: number): Array<number> {
    return Array(value)
      .fill(0)
      .map((_x, i) => i)
  }
}
